import { useEffect } from 'react';
import type { NavigateFunction } from 'react-router-dom';
import { ContentUtil } from 'utils/content';

import { content } from '../espn.content';
import { isContractInBinding } from '../utils/isContractBinding';

interface UseEspnEligibilityRedirectProps {
  contractEndDate?: string | null;
  hasDashboardProductsLoaded: boolean;
  hasDTV: boolean;
  hasError: boolean;
  isLoading: boolean;
  navigate: NavigateFunction;
}
const contentUtil = new ContentUtil({ content, componentName: 'Espn' });

export const useEspnEligibilityRedirect = ({
  contractEndDate,
  hasDashboardProductsLoaded,
  hasDTV,
  hasError,
  isLoading,
  navigate,
}: UseEspnEligibilityRedirectProps) => {
  const isEligible = hasDTV && !isContractInBinding(contractEndDate);
  const shouldRedirectToOverview = hasError || !isEligible;

  useEffect(() => {
    if (!hasDashboardProductsLoaded || isLoading || !shouldRedirectToOverview) {
      return;
    }

    const params = new URLSearchParams({
      'error-title': contentUtil.translateToString('eligibilityError.title'),
      'error-text': contentUtil.translateToString('eligibilityError.text'),
    });

    navigate(`/overzicht?${params.toString()}`, { replace: true });
  }, [hasDashboardProductsLoaded, isLoading, navigate, shouldRedirectToOverview]);

  return {
    isEligible,
    shouldRedirectToOverview,
    shouldShowGuardLoader: !hasDashboardProductsLoaded || isLoading || shouldRedirectToOverview,
  };
};
